import type { FaireProductEntity } from "../../entity_types/product";

export const p_wyaxz37cx3: FaireProductEntity = {
  token: "p_wyaxz37cx3",
  type: "product",
  name: "Lamare Guided Journal for Women",
  brandToken: "b_ebzv5q77kr",
  brandName: "Lamare",
  imageUrl:
    "https://cdn.faire.com/fastly/744153bb5b7b1019336239cb055a1340a95b5e6ebfcac79b9c9dc797f66208ec.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d53d0db64ad4b897ef368b5c047bda74834efb35277ce1f5a6853ae991baaba.png",
    "https://cdn.faire.com/fastly/c41874cb6ad592f7dc7f8a0173fed8f18a9ff855fc8265a8e07bdb89c100c594.png",
    "https://cdn.faire.com/fastly/8a027e3024b5756fe6b18a91337097d1f0056e461ace65a4550d9aab3ffd1648.png",
    "https://cdn.faire.com/fastly/236c78a239553e64b1a3cfdcf73914c813cf1aab20e73d06a321961a1b233f20.png",
    "https://cdn.faire.com/fastly/ca3a72b2f10fd0b9511da18fa200b6e7a3b19f15bddf62b8795e9d61948db17e.png",
    "https://cdn.faire.com/fastly/3354039aefc1d0bdf0f16a719860300db384a24634391dd942d77372f4ba7161.png",
    "https://cdn.faire.com/fastly/0b0626a4cf2ae2ba9dd169e33a0114088b72d2808d80804613ab5461f9b2a66a.png",
    "https://cdn.faire.com/fastly/90c6db694b6ced6447b4211185601e29379f3403943b814d1fd72ffe2e357039.png",
    "https://cdn.faire.com/fastly/fb221843eb90a9db530b0c41714279fb0189b117cab1935f48b312739e2f2ea3.png",
  ],
  priceDollars: 20.72,
  description:
    "Transform your thoughts into clarity with this guided journal designed to help you heal, reflect, and grow—one simple question a day. Thoughtfully structured for six months of intentional self-discovery, mindfulness, and gratitude.\n\nWhat’s Inside:\nOne question per day (one full page each)\n\n6 guided monthly themes: vision, self-discovery, mindfulness, healing, resilience & joy\n\nStructured reflection pages for deeper clarity\n\nSpace to build gratitude, confidence, and self-trust\n\nProduct Features:\n\n6-month guided format\n\nEasy, consistent daily prompts\n\nBeautiful, minimalist design\n\nPremium-quality paper\n\nLay-flat binding for a smooth writing experience\n\nThoughtful self-care & mental health gift",
  tags: [],
  msrpDollars: 34.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:40.469Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
